import forms from '../data/gravity-forms'

// Gravity Forms field definitions are baked into the bundle rather than
// sourced from WordPress at build time. See src/data/gravity-forms.js for why
// (WPGraphQL 2.x + gatsby-source-wordpress cannot source them reliably).
//
// Form submission is unaffected -- it is a runtime mutation against WPGraphQL
// from the browser, so entries and notification emails still flow through
// Gravity Forms in WordPress exactly as before.
const useFormQuery = () => forms

export default useFormQuery
